<div class="range-options">
  @for (prop of sliderProperties; track prop.id) {
  @if (prop.visible) {
  <app-vehicle-property [label]="prop.label" [displayValue]="prop.displayValue" [min]="prop.min" [max]="prop.max"
    [digit]="prop.digit" [step]="prop.step" [altString]="prop.altString" [value]="prop.value"
    (valueDragEvent)="sliderDragEvent.emit({ id: prop.id, value: $event })"
    (valueChangeEvent)="sliderChangeEvent.emit({ id: prop.id, value: $event })">
  </app-vehicle-property>
  }
  }
</div>